// extracted by mini-css-extract-plugin
export var planCard = "_sj-0";
export var planList = "_sj-1";